import { EntitiesTypes } from './actionTypes';

export const getEntitiesByType = () => ({
  type: EntitiesTypes.GET_ENTITIES_BY_TYPE,
});

export const getEntitiesByTypeSuccess = (payload: any) => ({
  type: EntitiesTypes.GET_ENTITIES_BY_TYPE_SUCCESS,
  payload,
});

export const getEntitiesByTypeFail = (error: any) => ({
  type: EntitiesTypes.GET_ENTITIES_BY_TYPE_FAIL,
  payload: error,
});
//EntitiesList---------------------------------------------------
export const getEntitiesList = (payload: any) => {
  return {
    type: EntitiesTypes.GET_ENTITIES_LIST,
    payload: payload,
  };
};

export const getEntitiesListSuccess = (data: any) => {
  return {
    type: EntitiesTypes.GET_ENTITIES_LIST_SUCCESS,
    payload: data,
  };
};

export const getEntitiesListFail = (error: any) => {
  return {
    type: EntitiesTypes.GET_ENTITIES_LIST_FAIL,
    payload: error,
  };
};

//Entity---------------------------------------------------
export const getEntity = (payload: any) => {
  return {
    type: EntitiesTypes.GET_ENTITY,
    payload: payload,
  };
};

export const getEntitySuccess = (data: any) => {
  return {
    type: EntitiesTypes.GET_ENTITY_SUCCESS,
    payload: data,
  };
};

export const getEntityFail = (error: any) => {
  return {
    type: EntitiesTypes.GET_ENTITY_FAIL,
    payload: error,
  };
};
export const getEntityReset = () => {
  return {
    type: EntitiesTypes.GET_ENTITY_RESET,
  };
};
